import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

export default makeStyles((theme) => ({
  dataTable: {
    borderCollapse: 'collapse',
    backgroundColor: '#FFFFFF',
    boxShadow:
    '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
    borderRadius: '5px 5px 0 0', 
    width: '100%',

    '& thead tr:first-child': {
      '& th:first-child': {
        borderRadius: '4px 0 0 0',
      },
      '& th:last-child': {
        borderRadius: '0 4px 0 0',
      },
    },
    
    '& thead tr': {
      backgroundColor: theme.palette.grey[800],
      color: '#FFFFFF',
      textTransform: 'uppercase',
      
      '& th': {
        padding: '1rem 5px',
        textAlign: 'center',
        fontSize: '1.1rem',
      },

      '& middle-col': {
        whiteSpace: 'break-spaces',
        minWidth: 50,
        maxWidth: 52,
      },
    },

    '& tbody tr': {
      borderBottom: '1px solid rgba(224, 224, 224, 1)',

      '&:nth-child(even)': {
        backgroundColor: '#EFEFEF',
      },

      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.15)',
      },

      '& td': {
        padding: '0.3rem',
        fontSize: '1.2rem',
        textAlign: 'center',
        '@media only screen and (max-width : 1800px)': {
          fontSize: '1.1rem',
        },
        '@media only screen and (max-width : 1700px)': {
          fontSize: '1.0rem',
        },
        '@media only screen and (max-width : 1570px)': {
          fontSize: '0.9rem',
        },
      },

    },

    '& tfoot tr': {
      '& td': {
        padding: 10,
      },
    },
  },
  
  noData: {
    width: '100%',
    height: '80vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    color: Colors.loginLigthenPrimaryColor,
    '& > span:first-child':{
      fontSize: 130,
    },
    '& > span:last-child':{
      fontSize: 30,
    },
  },
}))
